import UtilsSchema from "@repoflow/schema/utils";

import {
  fileId,
  bucketId,
  orgId,
  siteId,
  kind,
  name,
  visibility,
  hash,
  ext,
  extInput,
  size,
  status,
  description,
  tags,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  {
    id: "/Public/SiteFile",
    type: "object",
    properties: {
      fileId,
      bucketId,
      orgId,
      siteId,
      kind,
      name,
      visibility,
      hash,
      ext,
      size,
      status,
      description,
      tags,
      createdAt,
      updatedAt,
    },
  },
  // The form the browser renders on the upload screen.
  //
  // `file` is the file widget's value — a wrapper around a DOM File, which
  // cannot cross the wire — so the app never sends THIS shape to the API. It
  // picks the name, hash and extension out of it and posts
  // /Public/SiteFile/CreateInput instead. bucketws' /Public/BucketFile/Create
  // carries the identical note; the divergence is that this one has no `tags`
  // field, because tagging something you have not uploaded yet asks a question
  // before the answer is interesting. Tags are set on the details screen.
  {
    id: "/Public/SiteFile/Create",
    type: "object",
    properties: {
      file: {
        label: "File",
        widget: "file",
        type: "object",
        patternProperties: {
          "^.+$": {},
        },
      },
    },
    required: ["file"],
  },
  // What the create mutation actually receives; mirrors the non-null fields of
  // the GraphQL `SiteFileInputCreate`. Validate against this one server-side —
  // /Public/SiteFile/Create can never match an API payload.
  {
    id: "/Public/SiteFile/CreateInput",
    type: "object",
    properties: {
      name,
      hash,
      ext: extInput,
    },
    required: ["name", "hash", "ext"],
  },
  {
    id: "/Public/SiteFile/Update",
    type: "object",
    properties: {
      description,
      tags,
      visibility,
    },
    required: [],
  },
];
